<div class="page-header">
  <h3 class="page-title">
    {{'rdcPrimaryData' | translate}}
  </h3>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a class="main-color" routerLink="/">{{'home' | translate}}</a></li>
      <li class="breadcrumb-item active" aria-current="page">{{'rdcPrimaryData' | translate}}</li>
    </ol>
  </nav>
</div>
<div class="row">
  <div class="col-12">
    <div class="card">
  <div>
          <div class="filter-applied-class">
            <!-- <div class="form-check form-check-primary ml-2 mr-2" *ngIf="showIsMyOrders===true"
              [ngClass]="{'float-l':lang==='ar','float-r':lang!=='ar'}">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" [(ngModel)]="isMyOrders" (change)="rerender()">
                <i class="input-helper"></i>
                {{'myOrders' | translate}}
              </label>
            </div> -->

            <a *ngIf="isFilterApplied===true" href="javascript:(void)" class="main-color"
              (click)="openFilterPopup()">{{'filterApplied' |
              translate}}</a><i [ngClass]="{'float-l':lang==='ar','float-r':lang!=='ar'}"
              class="fa fa-filter mr-2 ml-2 mt-1 main-color c-pointer fz-25" (click)="openFilterPopup()"></i>



          </div>
        </div>

      <div class="card-body pt-2">

        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <table datatable #dtElement [dtOptions]="dtOptions" class="table width-100">
                <thead>
                  <tr class="bg-primary text-white">
                   
                    <th>{{'dataNumber' | translate}}</th>                    
                    <th>{{'assetType' | translate}}</th>
                    <th>{{'assetQuantity' | translate}}</th>
                    <th>{{'caseNumber' | translate}}</th>
                    <th>{{'senderFirstName' | translate}}</th>
                    <th>{{'senderLastName' | translate}}</th>
                    <th>{{'senderEmail' | translate}}</th>
                    <th>{{'senderPhoneNumber' | translate}}</th>
                    <th>{{'receiverName' | translate}}</th>
                    <th>{{'receiverAddress' | translate}}</th>
                    <th>{{'receiverPhoneNumber' | translate}}</th>
                    <th>{{'requestNumber' | translate}}</th>
                    <th>{{'createdOn' | translate}}</th>                    
                    <th>{{'status' | translate}}</th>
                    <th>{{'documentLink' | translate}}</th>
                    <!--  -->
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let  rdcprimarydata of  rdcprimarydataList">
                    <td>{{  rdcprimarydata.dataNumber }}</td>
                    <td>{{  rdcprimarydata.assetType }}</td>                    
                    <td>{{  rdcprimarydata.assetQuantity }}</td>    
                    <td>{{  rdcprimarydata.caseNumber }}</td>               
                    <td>{{  rdcprimarydata.senderFirstName }}</td>
                    <td>{{  rdcprimarydata.senderLastName }}</td>
                    <td>{{  rdcprimarydata.senderEmail }}</td>
                    <td>{{  rdcprimarydata.senderPhoneNumber }}</td>
                    <td>{{  rdcprimarydata.receiverName }}</td>
                    <td>{{  rdcprimarydata.receiverAddress }}</td>
                    <td>{{  rdcprimarydata.receiverPhoneNumber }}</td>
                    
                    <td>
                      <a class="main-color" (click)="goToOrderDetails(rdcprimarydata)" href="javascript:(void)">
                        {{rdcprimarydata.requestNumber}}
                      </a>
                    </td>                    
                   <td>{{ rdcprimarydata.createdOn | customDate:"dd MMM, yyyy hh:mm a" }}</td>
                   <td>{{ rdcprimarydata.statusName }}</td>
                    <td> 
                      <a *ngIf="rdcprimarydata.documentLink !== null && rdcprimarydata.documentLink !== ''"
                              class="main-color mr-2 ml-2" [href]="sanitize(rdcprimarydata.documentLink)" target="_blank"                             
                              rel="noopener noreferrer" title="{{rdcprimarydata.documentLink}}">
                              <i class="fa fa-paperclip fz-25"></i></a>
                    </td>
                   
                  </tr>


                </tbody>
                <tbody *ngIf="rdcprimarydataList?.length == 0">
                  <tr>
                    <td colspan="3" class="no-data-available">{{'noDataFound' | translate}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>